import { getViewFormat } from 'src/hooks/block/get-view-format';
import { updateBlock } from 'src/redux/managers/block/update';
import * as CollectionViewManager from 'src/redux/managers/collection-view';
import { getState } from 'src/redux/store';
import type { CollectionWhere } from 'src/redux/types';

import { getValuesFromGroupValue } from '../collection-view/get-values-from-groupvalue';
import { checkPageSort } from './use-insert-record';

export const sortRecord = (
  viewId: string,
  sourceBlocks: { uuid: string; oldGroupValues?: Record<string, string[]> }[],
  where: CollectionWhere
) => {
  sourceBlocks.reduce((newWhere, uuid) => {
    sort(viewId, uuid, newWhere);
    return { ...newWhere, after: uuid.uuid, before: undefined };
  }, where);
};

const sort = (
  viewId: string,
  sourceBlock: { uuid: string; oldGroupValues?: Record<string, string[]> },
  where: CollectionWhere
) => {
  const { uuid, oldGroupValues } = sourceBlock;
  const viewInfo = getViewFormat(viewId);
  if (!viewInfo) return;

  const { view, collection } = viewInfo;

  const { blocks } = getState();
  const block = blocks[uuid];
  const targetBlock = blocks[(where.after || where.before) ?? ''];
  if (!block || !targetBlock) return;

  const { newPageSort } = checkPageSort(view.pageSort, collection.subNodes);
  const uuidIndex = newPageSort.indexOf(uuid);
  const targetIndex = newPageSort.indexOf((where.before || where.after) ?? '');

  if (where.last) {
    newPageSort.push(uuid);
  } else if (where.first) {
    newPageSort.unshift(uuid);
  } else if (where.after) {
    newPageSort.splice(targetIndex + 1, 0, uuid);
  } else {
    newPageSort.splice(targetIndex, 0, uuid);
  }

  if (uuidIndex < targetIndex) {
    newPageSort.splice(uuidIndex, 1);
  } else {
    newPageSort.splice(uuidIndex + 1, 1);
  }

  CollectionViewManager.update(viewId, {
    pageSort: newPageSort,
  });

  const newCollectionProperties = getValuesFromGroupValue({
    viewId,
    groupValue: where.groupValue,
    subGroupValue: where.subGroupValue,
    blockId: uuid,
    oldGroupValues,
  });

  if (Object.keys(newCollectionProperties).length > 0) {
    updateBlock(uuid, {
      data: {
        segments: newCollectionProperties.title ?? block.data.segments,
        collectionProperties: {
          ...block.data.collectionProperties,
          ...newCollectionProperties,
        },
      },
    });
  }
};
